import { render, staticRenderFns } from "./AppProviders.vue?vue&type=template&id=5b839b6d&scoped=true"
import script from "./AppProviders.vue?vue&type=script&lang=js"
export * from "./AppProviders.vue?vue&type=script&lang=js"
import style0 from "./AppProviders.vue?vue&type=style&index=0&id=5b839b6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b839b6d",
  null
  
)

export default component.exports